module.exports = __webpack_public_path__ + "static/media/pdf-background.6c6daecf.png";